import { useTranslation } from "react-i18next";
import type { PaymentMethod } from "../api";
import { PAYMENT_METHODS } from "../api";
import { Label } from "./ui/label";
import { Select } from "./ui/select";

/**
 * To'lov usuli tanlovi — pul harakat qiladigan barcha formalarda bitta nazorat.
 *
 * Bo'sh qiymat ("—") HAR DOIM tanlanadigan bo'lib qoladi: saqlangan `null`
 * "yozilmagan" degani, `naqd` emas. Mavjud qatorlar hech qachon backfill
 * QILINMAYDI va noma'lum hisobotda hech qachon "Naqd"ga qo'shilmaydi — bu
 * qoida o'zgarmadi (docs/claude/payments.md).
 *
 * Lekin SUKUT QIYMATI formaning turiga bog'liq, va uni komponent emas, har bir
 * forma o'zi beradi:
 *   • hujjat YARATILAYOTGAN forma (ish / sotuv / xarid / qaytarish) `naqd` bilan
 *     ochiladi — odam aynan hozir to'lovni yozyapti, eng ko'p uchraydigan usul
 *     esa naqd; bir bosish bilan o'zgartiriladi. Mobil ilova ham shunday qiladi.
 *   • MAVJUD qarzga to'lov qabul qilinayotgan dialog (qarz to'lovi, hujjat
 *     qarzini so'ndirish, yetkazib beruvchiga to'lov) bo'sh qoladi — bular kam
 *     uchraydigan, o'ylab qilinadigan amallar, u yerda ochiq tanlov to'g'ri.
 *
 * Yorliqlar `common.json` da — ular ish, ombor va qarzlar bo'limlarida bir xil
 * bo'lishi kerak.
 */
export function PaymentMethodSelect({
  value,
  onChange,
  id = "tolov-usuli",
  disabled,
  /** Nol to'lovda usul yozilmaydi — forma maydonni o'chirib qo'yadi. */
  hideLabel,
  className,
}: {
  value: PaymentMethod | "";
  onChange: (value: PaymentMethod | "") => void;
  id?: string;
  disabled?: boolean;
  hideLabel?: boolean;
  className?: string;
}) {
  const { t } = useTranslation("common");
  return (
    <div className={className}>
      {!hideLabel && (
        <Label htmlFor={id} className="text-xs text-muted-foreground">
          {t("paymentMethod.label")}
        </Label>
      )}
      <Select
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as PaymentMethod | "")}
      >
        <option value="">{t("paymentMethod.unset")}</option>
        {PAYMENT_METHODS.map((m) => (
          <option key={m} value={m}>
            {t(`paymentMethod.${m}`)}
          </option>
        ))}
      </Select>
    </div>
  );
}

/** Jadval kataklari uchun yorliq; yozilmagan bo'lsa "—". */
export function usePaymentMethodLabel() {
  const { t } = useTranslation("common");
  return (usul: PaymentMethod | null | undefined) =>
    usul ? t(`paymentMethod.${usul}`) : "—";
}

/**
 * Hujjat tafsiloti uchun yorliq — yozilmagan bo'lsa "Noma'lum".
 *
 * `usePaymentMethodLabel` dan farqi ATAYLAB: zich jadval ustunida chiziqcha
 * o'qiladi, hujjatning to'lov tafsilotida esa yo'q. Aynan shu so'z usul
 * bo'linishi kartochkasidagi noma'lum guruhi bilan bir xil, shunda egasi bu
 * yerda "Noma'lum" ko'rgan hujjatni o'sha guruh ichidan topadi.
 */
export function usePaymentMethodText() {
  const { t } = useTranslation("common");
  return (usul: PaymentMethod | null | undefined) =>
    usul ? t(`paymentMethod.${usul}`) : t("paymentMethod.nomalum");
}
